import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { StorageServiceModule } from 'services/storage/storage.service';

export const GreetingServiceModule = angular
    .module('app.services.greetingService', [
        AuthTokenServiceModule,
        StorageServiceModule
    ]).service('greetingService', (
        $q,
        $http,
        $location,
        storageService,
        authTokenService
    ) => {
        return {
            isGreetingFinished,
            doesProfileExist,
            getProfile,
            saveProfile,
            getRootDomain
        };

        function isGreetingFinished() {
            const rootDomain = getRootDomain($location.host());
            const tenantId = authTokenService.getTenantId();
            let greetingFinished = storageService.getCookieObject(tenantId, 'greetingFinished');
            if (angular.isUndefined(greetingFinished) || greetingFinished === null || greetingFinished === false) {
                return doesProfileExist().then((profileExists) => {
                    storageService.updateCookieObject(tenantId,
                        { greetingFinished: profileExists },
                        { secure: true, domain: rootDomain });
                    return profileExists;
                });
            }
            return $q.resolve(greetingFinished);
        }

        function doesProfileExist() {
            return $http.get(`${process.env.BASE_API_URL}/admin/profile`)
                .then((profileResult) => {
                    return profileResult.data.isComplete;
                });
        }

        function getProfile() {
            return $http.get(`${process.env.BASE_API_URL}/admin/profile`);
        }

        function saveProfile(profile) {
            return $http.put(`${process.env.BASE_API_URL}/admin/profile`, profile).then((response) => {
                storageService.updateCookieObject(authTokenService.getTenantId(),
                    { greetingFinished: true },
                    { secure: true, domain: getRootDomain($location.host()) });
                return response;
            });
        }

        function getRootDomain(hostname) {
            let parts = hostname.split('.');
            let hasSubdomain = parts.length === 3;
            return hasSubdomain ? `${parts[1]}.${parts[2]}` : hostname;
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/greeting.service.js